<template>
  <div>
    <Modal
      v-model="modalAdd"
      title="IM消息"
      :closable="false"
      :mask-closable="false"
      @on-ok="addRecord"
    >
      <div class="add-item">
        <span>发送内容：</span>
        <Input
          class="input"
          type="textarea"
          :rows="4"
          v-model="content"
          placeholder="请输入发送内容"
          clearable
        />
      </div>
      <div class="add-item">
        <span>发送sql：</span>
        <Input
          class="input"
          type="textarea"
          :rows="4"
          v-model="sql"
          placeholder="请输入发送sql"
          clearable
        />
      </div>
    </Modal>
    <div class="table-head">
      <Button @click="modalAdd = true">新建发送</Button>
    </div>
    <Table :columns="columns" :data="messageList">
      <template slot-scope="{ row }" slot="created_at">
        <span>{{ row.created_at }}</span>
      </template>

      <template slot-scope="{ row }" slot="sql">
        <span>{{ row.sql }}</span>
      </template>

      <template slot-scope="{ row }" slot="content">
        <span>{{ row.content }}</span>
      </template>

      <template slot-scope="{ row }" slot="status">
        <span>{{ status[row.status.toString()] }}</span>
      </template>

      <template slot-scope="{ row }" slot="reason">
        <span>{{ row.reason }}</span>
      </template>

      <template slot-scope="{ row }" slot="finish_time">
        <span>{{ row.finish_time }}</span>
      </template>
    </Table>
    <div class="text-center" style="margin-top: 10px;" v-show="messageList.length != 0">
      <Page
        show-elevator
        :page-size="pageOption.page_size"
        :total="pageOption.total"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import apis from "../../http/api";

export default {
  data() {
    return {
      status: {'0':'发送中', '1':'已发送', '-1':'发送失败'},
      modalAdd: false,
      content: '',
      sql: '',
      messageList: [],
      pageOption: {
        page_size: 20,
        total: 100,
        page: 1
      },
      columns: [
        {
          title: '发送时间',
          slot: 'created_at',
          width: 180
        },
        {
          title: '发送sql',
          slot: 'sql'
        },
        {
          title: '发送内容',
          slot: 'content'
        },
        {
          title: '是否发送',
          slot: 'status',
          width:100
        },
        {
          title: '失败原因',
          slot: 'reason',
        },
        {
          title: '完成时间',
          slot: 'finish_time',
          width: 180
        },
      ]
    }
  },
  async created() {
    await this.getList()
  },
  methods: {
    addRecord() {
      let post_data = {
        select_sql: this.sql,
        send_content: this.content
      }
      apis.send_message_to_many(post_data).then(res => {
        const { data, errCode, msg } = res
        if (errCode === 0) {
          this.$Message.success('发送成功！')
          this.sql = ''
          this.content = ''
          this.getList()
        }else {
          alert(msg)
        }
      }).catch(res => {
        console.log(res)
      })
    },
    getList() {
      apis.message_record({
        page: this.pageOption.page,
        size: this.pageOption.page_size
      }).then(res => {
        this.messageList = res.data.records
        this.pageOption.total = res.data.total_pages * 20
      })
    },
    pageChange(page) {
      this.pageOption.page = page;
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
.table-head {
  text-align: right;
  padding: 5px;
}
.add-item {
  display: flex;
  margin-left: 65px;
  margin-top: 20px;
}

.add-item:last-child {
  margin-bottom: 30px;
}
.add-item span {
  width: 20%;
}
.input {
  width: 60%;
}
.text-center {
  text-align: center;
}
</style>
